module.exports = __webpack_public_path__ + "img/obituary.ff318419.svg";